import Head from 'next/head'

export function HeadMeta({
  children,
  title = '',
  description = '',
  image = 'https://backupdiary.com/social-image.png',
}: React.PropsWithChildren & {
  title?: string
  image?: string
  description?: string
}) {
  const fullTitle = title?.length
    ? `${title} - Backup Diary`
    : 'Backup Diary — a private note for the people who matter most'

  return (
    <Head>
      <title>{fullTitle}</title>
      <link rel="icon" href="/icon.svg" />
      <meta property="og:title" content={fullTitle} />
      <meta name="twitter:site" content="@UseBackupDiary" />
      <meta property="og:site_name" content="Backup Diary" />
      <meta name="twitter:card" content="summary_large_image" />

      {description.length > 0 ? (
        <meta
          name="description"
          content={description}
          itemProp="description"
          property="og:description"
        />
      ) : (
        ''
      )}
      {image.length > 0 ? (
        <meta itemProp="image" property="og:image" content={image} />
      ) : (
        ''
      )}

      {children}
    </Head>
  )
}
